import { useDateLocale, useTimeZone } from '../../../../../hooks'
import { EntityProfileHeaderInfoItemBase } from '../../../../Entity'
import Text from '../../../../Text'
import { getViewingProfileTimeLabel } from '../../RentalPortalViewingProfile.utils'
import { QA_NAME_VIEWING_PROFILE_INFO_TIME } from '../RentalPortalViewingProfileHeaderInfoItems.constants'

function ViewingProfileTimeItem({
  className,
  contentWrapperClassName,
  titleClassName,
  viewing,
}) {
  const locale = useDateLocale()
  const timezone = useTimeZone()

  return (
    <EntityProfileHeaderInfoItemBase
      actions={null}
      canEdit={false}
      className={className}
      contentWrapperClassName={contentWrapperClassName}
      title='RentalPortal.ViewingDateTimeColumnKey'
      titleClassName={titleClassName}
    >
      <Text qaName={QA_NAME_VIEWING_PROFILE_INFO_TIME}>
        {getViewingProfileTimeLabel({ locale, timezone, viewingData: viewing })}
      </Text>
    </EntityProfileHeaderInfoItemBase>
  )
}

export default ViewingProfileTimeItem
